package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.constants.StringConstants.Regex.ALEF_TAV
import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.screens.mikud.model.MikudData
import com.eladfinish.bible.contest.utils.gematriaWord
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.toImmutableList
import kotlin.time.measureTime

class ParseMikudUseCase(
    private val populateBookUseCase: PopulateBookUseCase,
    private val getFilteredMikudListUseCase: GetFilteredMikudListUseCase,
    private val buildBooksListUseCase: BuildBooksListUseCase,
) {

    operator fun invoke(text: String): MikudData {
        val mikud = buildBooksListUseCase(full = false).toMutableList()
        measureTime {
            val bibleBooksHeb = BibleCatalog.books.map { it.hebrew }
            val filteredList = getFilteredMikudListUseCase(text)

            val indexesOfBookName = filteredList.map { it to bibleBooksHeb.indexOf(it) }
                .plus("-" to 100) // dummy for including the last book in the list

            Napier.d("filteredList $filteredList")

            indexesOfBookName.asSequence().withIndex()
                .filter {
                    it.value.second != -1
                }
                .map {
                    it.index
                }
                .zipWithNext()
                .map {
                    indexesOfBookName.subList(it.first, it.second)
                }
                .map { pairList ->
                    val index = pairList[0].second
                    if (pairList.size == 1) {
                        val chapters = (1..mikud[index].chapters.size).toList()
                        index to chapters
                    } else {
                        val chapters =
                            pairList.subList(1, pairList.size).map { it.first }.map { convertLettersToNumbers(it) }.flatten()
                        index to chapters
                    }
                }
                .forEach { (index: Int, chapters: List<Int>) ->
                    populateBookUseCase(mikud = mikud, index = index, chapters = chapters)
                }
        }.also {
            Napier.d("duration: $it")
        }
        return mikud.toImmutableList()
    }

    private fun convertLettersToNumbers(str: String): List<Int> {
        val chaptersRegex = "($ALEF_TAV{1,3})'?(?:\\s?-\\s?($ALEF_TAV{1,3})'?)?"
        var startChapter = ""
        var endChapter = ""
        chaptersRegex.toRegex().find(str)?.let {
            startChapter = it.groupValues.getOrNull(1).orEmpty()
            endChapter = // there is a hyphen (makaf) between the letters, so this is a range
                it.groupValues.getOrNull(2) ?: startChapter // otherwise - no range, startChapter and endChapter are the same chapter
        }
        val startFrom = startChapter.gematriaWord()
        val stopAt = endChapter.gematriaWord()
        return (startFrom..stopAt).toList()
    }
}
